import React from 'react';
import { Switch } from 'react-router-dom';

import { metadataRoute } from '~/routes'
import RouteWrapper from '~/routes/RouteWrapper';
import List from './List';
import Show from './Show';
import Edit from './Edit';
import New  from './New';

export default function MetadataRoutesComponent() {
  return (
    <Switch>
      <RouteWrapper
        exact
        isPrivate
        path={metadataRoute.new.path}
        component={New}
        permissionKeyCode="Metadatum"
        permission="add"
      />
      <RouteWrapper
        exact
        isPrivate
        path={metadataRoute.clone.path}
        component={New}
        permissionKeyCode="Metadatum"
        permission="add"
      />
      <RouteWrapper
        exact
        isPrivate
        path={metadataRoute.show.path}
        component={Show}
        permissionKeyCode="Metadatum"
        permission="see"
      />
      <RouteWrapper
        exact
        isPrivate
        path={metadataRoute.edit.path}
        component={Edit}
        permissionKeyCode="Metadatum"
        permission="edit"
      />

      <RouteWrapper
        isPrivate
        redirectIfNotExact
        path={metadataRoute.list.path}
        component={List}
        permissionKeyCode="Metadatum"
        permission="see"
      />
    </Switch>
  );
}
